<script lang="ts">
	import { getTranslate } from '@tolgee/svelte';
	import SignUpForm1 from '$lib/components/Form/SignUpForm1.svelte';
	import SignUpFormSocialUsername from '$lib/components/Form/SignUpFormSocialUsername.svelte';

	export let socialStep: boolean = false;

	const { t } = getTranslate();
</script>

<div class="w-full">
	<div class="flex flex-row justify-center w-full">
		<div class="min-w-[340px] md:min-w-[400px]">
			{#if socialStep}
				<SignUpFormSocialUsername on:success on:error />
			{:else}
				<div>
					<h1 class="mb-8 text-xl font-semibold self-start">{@html $t('signup.step0.headline')}</h1>
				</div>
				<SignUpForm1 on:success on:error />
			{/if}
		</div>
	</div>
</div>
